import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ImageInput = ({ value, onChange, testid, video = false }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success(video ? "Video uploaded" : "Image uploaded");
    } catch (err) {
      toast.error("Upload failed — check file size (images 10MB, videos 100MB)");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testid}
          placeholder={video ? "Paste video URL or upload from device" : "Paste image URL or upload from device"}
          className="input-lux flex-1"
        />
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          data-testid={`${testid}-upload-button`}
          className="btn-ghost-lux shrink-0 px-4 py-2.5 text-xs"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <Upload className="h-4 w-4" aria-hidden="true" />}
          {uploading ? "Uploading" : "Upload"}
        </button>
      </div>
      <input ref={fileRef} type="file" accept={video ? "video/mp4,video/webm,video/quicktime" : "image/*"} onChange={upload} className="hidden" aria-hidden="true" tabIndex={-1} />
      {value && !video && <img src={value} alt="Preview" className="h-20 w-20 rounded-xl object-cover" />}
      {value && video && <video src={value} muted playsInline className="h-24 rounded-xl" data-testid={`${testid}-preview`} />}
    </div>
  );
};
